<template>
	<div class="Item">
		<headerItem msg="2024年月进件情况图表" bgColor="" titleBeforeColor="" rightIcon=""></headerItem>
		<div class="grid-container">
			<div ref="chart" id="chart" style="width: 100%; min-height: 320px;" class="flex-1 charts-style"></div>
		</div>
	</div>
</template>
<script>
import headerItem from '../components/headerItem.vue';
import * as echarts from 'echarts';
export default {
	name: '',
	components: {
		headerItem
	},
	props: {
		current: Number,
	},
	watch: {
		current(newVal, oldVal) {
			if (newVal === 1) {
				this.listData = this.listData1
			} else if (newVal === 0) {
				this.listData = this.listData0
			}
			this.initChart(this.listData);
		}
	},
	data() {
		return {
			chart: null,
			listData: {},
			listData0: {
				data1: [105, 641, 3118],
				data2: [62, 393, 2032]
			},
			listData1:
			{
				data1: [2578, 897, 2077],
				data2: [1380, 275, 973]
			}
		}
	},
	created() {
		this.listData = this.listData0
	},
	mounted() {
		this.initChart(this.listData);
	},
	methods: {
		initChart(list) {
			const myChart = echarts.init(this.$refs.chart);
			const option = {
				grid: {
					left: '5%',
					right: '5%',
					top: '20%',
					bottom: '5%',
					containLabel: true
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						lineStyle: {
							color: '#57617B'
						}
					}
				},
				legend: {
					align: "left",
					right: '10%',
					top: '10%',
					type: 'plain',
					textStyle: {
						color: '#7ec7ff',
						fontSize: 6
					},
					itemGap: 6,
					itemWidth: 6,
					icon: 'path://M0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
					data: ['总数量', '成功数']
				},
				xAxis: [
					{
						type: 'category',
						boundaryGap: false,
						axisLabel: {
							color: '#fff',
							fontSize: 16
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#0D1543'
							}
						},
						data: ['一月', '二月', '三月', '四月']
					}
				],
				yAxis: [
					{
						type: 'value',
						nameTextStyle: {
							color: '#fff',
							fontSize: 16
						},
						axisLabel: {
							formatter: '{value}',
							textStyle: {
								color: '#fff',
								fontSize: 16
							}
						},
						axisLine: {
							lineStyle: {
								color: '#0D1543'
							}
						},
						axisTick: {
							show: false,
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#0D1543'
							}
						}
					}
				],
				series: [
					{
						name: '总数量',
						type: 'line',
						symbol: 'circle',
						symbolSize: 2,
						// smooth:true,  //这个是把线变成曲线
						itemStyle: {
							normal: {
								color: '#0092f6',
								lineStyle: {
									color: "#0092f6",
									width: 1
								},
								areaStyle: {
									//color: '#94C9EC'
									color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
										offset: 0,
										color: 'rgba(7,44,90,0.3)'
									}, {
										offset: 1,
										color: 'rgba(0,146,246,0.9)'
									}]),
								}
							}
						},
						data: list.data1
					},
					{
						name: '成功数',
						type: 'line',
						symbol: 'circle',
						symbolSize: 2,
						// smooth:true,  //这个是把线变成曲线
						itemStyle: {
							normal: {
								color: '#00d4c7',
								lineStyle: {
									color: "#00d4c7",
									width: 1
								},
								areaStyle: {
									//color: '#94C9EC'
									color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
										offset: 0,
										color: 'rgba(7,44,90,0.3)'
									}, {
										offset: 1,
										color: 'rgba(0,212,199,0.9)'
									}]),
								}
							}
						},
						data: list.data2
					}
				]
			}
			myChart.setOption(option);
			window.onresize = function () {
				myChart.resize();
			}
		}
	},
	beforeDestroy() {
		if (this.chartInstance) {
			this.chartInstance.dispose(); // 清理chart实例
		}
	}
}
</script>
<style lang="less" scoped>
.Item {
	.grid-container {
		width: 100%;
		// margin: 10px auto 0;
		display: grid;
		grid-template-columns: 1fr;
		/* 这表示列的大小为1fr */
		grid-template-rows: 1fr;
		/* 这表示行的大小为1fr */
		justify-items: center;

		.grid-item {
			box-sizing: border-box;
			border: 1px solid #e4e4e4;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			text-align: center;
			padding: 20px;
		}
	}
}
</style>
